const storageTypeLabel = (storageType) => {
  return (
    {
      1: 'Definido',
      2: 'Indefinido',
      3: 'Permanente',
    }[storageType] || storageType
  )
}

export default storageTypeLabel
